import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

// #39 (Bloque A): shared consumption-mode selector reused by every widget that shows/changes a
// machine's Machine Storage consumption mode (the components widget, ResourceListWidget, and the
// 3 Active Jobs widgets — S5). `mode` always comes from the server via useConsumptionMode /
// MosInfoProvider, never local component state (S4). `disabled` keeps the current mode visible but
// blocks the change when the worker lacks the MACHINE_STORAGE_CHANGE_CONSUMPTION_MODE capability
// (S7) — labels reuse the existing FIFO/Balanced/Selection i18n keys from #19.
const ConsumptionModeSelector = ({ mode, onChange, disabled = false, size = 'small', sx = {} }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', ...sx }}>
      <ToggleButtonGroup
        size={size}
        exclusive
        value={mode}
        onChange={(event, newMode) => { if (newMode) onChange(newMode) }}
        aria-label={t_('Consumption strategy')}
      >
        <ToggleButton value='FIFO' disabled={disabled}>{t_('FIFO')}</ToggleButton>
        <ToggleButton value='EQUILIBRADO' disabled={disabled}>{t_('Balanced')}</ToggleButton>
        <ToggleButton value='SELECCION' disabled={disabled}>{t_('Selection')}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default ConsumptionModeSelector
